import {
	HasNoSalePrice,
	Price,
	SimpleDisplayPrice,
} from '../../../../../../Roc.SharedClientApp/types/commerce/display-price';

/**
 * The pricing row for pricing table
 */
export interface CalculatorPricingTableRow {
	/**
	 * The starting quantity for this pricing row/range
	 */
	quantity: number;
	/**
	 * The price applicable to this pricing row/range
	 */
	price: SimpleDisplayPrice<Price> & HasNoSalePrice;
}

/**
 * The calculator quote model
 */
export interface CalculatorQuote {
	/**
	 * The product name
	 */
	productName: string | null;
	/**
	 * The product number
	 */
	productNumber: string;
	/**
	 * The calculator name
	 */
	calculatorName: string;
	/**
	 * The customer name
	 */
	customerName: string;
	/**
	 * The size requested by the customer
	 */
	sizeRequested: string;
	/**
	 * The lead time
	 */
	leadTime: string;
	/**
	 * The minimum order quantity value for requested product
	 */
	moq: number;
	/**
	 * The pricing table (quantity ranges)
	 */
	pricingTable: CalculatorPricingTableRow[];
	/**
	 * The message about validity of this quote
	 */
	validFromLocalizedMessage: string;
	/**
	 * The URL to the product image
	 */
	productImageUrl: string;
	/**
	 * The id of this quote
	 */
	id: string;
	/**
	 * The number of this quote
	 */
	quoteNo: string;
	/**
	 * The flag indicating whether the quoted product is stock item or non-stock (made to order / cut to order)
	 */
	isStockProduct: boolean;

	/**
	 * The type of calculator that has been used to submit the quote
	 */
	calculatorType: CalculatorType;
}

export enum CalculatorType {
	AbrasiveBelts = 'AbrasiveBelts',
	CustomCutTapeShape = 'CustomCutTapeShape',
	CustomShortLength = 'CustomShortLength',
	CustomWidthRoll = 'CustomWidthRoll',
}

export interface CalculatorQuoteDetails {
	notes: string;
	emailAddresses: string;
}

export interface AdditionalUrls {
	productUrl: string | null;
	safetyDataSheetUrl: string | null;
	regulatoryDataSheetUrl: string | null;
	safetyInsertsUrl: string | null;
}

/**
 * The response model for quote submission
 */
export interface GetQuoteResponse {
	/**
	 * If quote has been successfully submitted then this is the quote id, otherwise null
	 */
	quoteId: string | null;
	/**
	 * The flag indicating whether quote has been successfully submitted or not
	 */
	submitted: boolean;
	/**
	 * If the selected filters are matching one of ready to buy products then this will be URL of that product and user should be redirected there
	 */
	redirectUrl: string | null;
	/**
	 * If something has gone wrong during quote submission then this is be the error message for the custmer, otherwise null
	 */
	errorMessage: string | null;
}
